<template>
    <div v-if="session" class="game-responsive responsive_9x16">
        <iframe id="mascot-container" ref="container" sandbox="allow-same-origin allow-scripts allow-popups allow-forms">
        </iframe>
    </div>
</template>

<script>
import Vue from "vue";
import isMobile from "ismobilejs";

export default {
    name: "game-mascot",
    computed: {
        lang: function() {
            return Vue.state.lang.currentLang;
        },
        session: function() {
            return Vue.state.mascot.session.get();
        },
        isLoggedIn: function() {
            return Vue.state.player.isLoggedIn();
        },
        container: function() {
            return this.$refs.container;
        }
    },
    props: {
        gameId: {
            type: String,
            required: true
        },
        backUrl: {
            type: String,
            required: true
        }
    },
    methods: {
        async resetFrameAsync() {
            await Vue.state.player.ensure();
            if (this.isLoggedIn) {
                await Vue.state.mascot.session.open({ gameId: this.gameId, lang: this.lang, isMobile: isMobile.any });
            } else {
                await Vue.state.mascot.session.openDemo({ gameId: this.gameId, lang: this.lang, isMobile: isMobile.any });
            }

            this.container.src = this.session.sessionUrl;
        },
    },
    mounted() {
        this.resetFrameAsync();
    },
    destroyed() {
        this.container && (this.container.innerHTML = "");
    }
};
</script>

<style lang="scss">
</style>


// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/game/game-mascot.vue